import { IconKey } from '@platform/components';

// Use grep -oP '"icon":\s*"\K[^"]+' input.txt | sort | uniq > unique_icons.txt to figure out the unique icons we need to support
// TODO: Redo this after the Contentful audit is complete so we don't bring in unnecessary icons. For now, only the icons with obvious replacements
// have been mapped.

/** Maps the old Font Awesome icons used by the legacy app implementation of the Contentful pages to new icons from the Design System */
export const legacyIconsToNewIcons: Record<string, IconKey | null> = {
  ambulance: null,
  award: null,
  'badge-check': null,
  'balance-scale': null,
  'balance-scale-right': null,
  'ballot-check': null,
  ban: null,
  bolt: 'zap',
  book: 'book-open-01',
  'book-reader': null,
  briefcase: null,
  browser: 'browser',
  building: 'building-04',
  bullhorn: 'announcement-01',
  bullseye: null,
  'bullseye-arrow': null,
  'business-time': null,
  calendar: null,
  'calendar-check': 'calendar-check-01',
  'calendar-day': null,
  camera: null,
  'chair-office': null,
  'chalkboard-teacher': null,
  'chart-bar': null,
  'chart-line': 'line-chart-up-02',
  'chart-network': 'globe-02',
  'chart-pie': null,
  check: 'check',
  city: null,
  'clipboard-check': null,
  'clipboard-list': null,
  'clipboard-list-check': null,
  'code-branch': null,
  cogs: null,
  'comment-alt-smile': null,
  'comment-lines': null,
  comments: 'message-chat-circle',
  'comments-alt': null,
  'comments-alt-dollar': null,
  'comment-smile': null,
  compass: 'compass-03',
  database: null,
  'dollar-sign': null,
  envelope: 'mail-01',
  'envelope-open-text': null,
  'external-link-alt': 'external-link',
  'file-chart-line': null,
  'file-chart-pie': null,
  'file-edit': 'edit-01',
  'file-signature': null,
  'file-user': null,
  flask: null,
  gavel: null,
  globe: 'globe-02',
  'globe-americas': 'globe-02',
  'graduation-cap': null,
  hammer: null,
  'hand-heart': 'heart-hand',
  'hand-holding-heart': 'heart-hand',
  'hand-holding-seedling': 'bank',
  'hand-holding-water': null,
  handshake: 'users-02',
  'handshake-alt': null,
  'hands-heart': null,
  'hands-helping': null,
  'hands-usd': null,
  'head-side': null,
  history: null,
  hotel: null,
  'industry-alt': null,
  infinity: null,
  'info-circle': 'info-circle',
  laptop: null,
  'lightbulb-exclamation': 'lightbulb-02',
  linkedin: 'linked-in',
  male: null,
  map: null,
  'map-marker': 'marker-pin-01',
  medal: null,
  megaphone: null,
  'mind-share': null,
  'money-bill': null,
  'money-check-edit-alt': null,
  'monitor-heart-rate': null,
  'network-wired': null,
  newspaper: null,
  'pen-alt': null,
  'pencil-paintbrush': null,
  'person-sign': null,
  phone: 'phone',
  plane: 'plane',
  poll: null,
  'poll-people': null,
  presentation: null,
  'project-diagram': null,
  question: 'help-circle',
  'repeat-alt': 'refresh',
  'reply-all': null,
  rocket: 'rocket-01',
  running: null,
  search: 'search-lg',
  'search-dollar': null,
  'search-location': null,
  'search-plus': null,
  share: 'share-01',
  'shield-check': null,
  spa: null,
  'street-view': null,
  'tablet-alt': null,
  tasks: null,
  'temperature-high': null,
  'thermometer-full': null,
  'thermometer-half': null,
  'thermometer-quarter': null,
  'thermometer-three-quarters': null,
  tools: null,
  'tree-alt': null,
  typewriter: null,
  'universal-access': null,
  'user-alt': null,
  'user-chart': 'line-chart-up-02',
  'user-circle': null,
  'user-edit': null,
  'user-friends': null,
  'user-plus': 'plus-circle',
  users: 'users-02',
  'users-class': 'book-open-01',
  'user-tie': null,
  video: null,
  'video-plus': null,
  youtube: 'youtube',
};
